import React from 'react';
import { Route, RouteProps } from 'react-router-dom';

const PublicRoute: React.FC<RouteProps> = ({ component: Component, ...rest }) => {
  return <Route {...rest} render={props => Component && <Component {...props} />} />;
};

export default PublicRoute;
